import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import './JurySheet.scss';

import { getCurrentMeet } from 'selectors';
import {
  getSessionOptions,
  getFlightOptions,
  getPlatformOptions
} from 'util/options';

import {
  getLifterAwardsWeightClassDoc
} from 'util/lifterHelper';


const LiftCell = ({lift}) => {
  return (
    <table className="lift-cell">
      <tbody>
        <tr>
          <td className="infraction-card"></td>
          <td className="infraction-card"></td>
          <td className="infraction-card"></td>
        </tr>
        <tr>
          <td colSpan="3">
            {lift && lift.weight}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

const SheetBody = ({meet, platformId, session, flight, lifters}) => {

  // ensure we have at least 15 rows
  if(_.size(lifters) < 15) {
    lifters = _.assign(_.fill(new Array(15), 0), lifters);
  }

  lifters = _.sortBy(lifters, ['name', 'lot']);

  const platform = _.find(meet.platforms, {'_id': platformId});
  const platformName = _.get(platform, 'name');

  return (
    <div className="flight-pages">
      <table>
        <thead>
          <tr>
            <th colSpan="16">
              {meet.date} - {meet.name} - Session {session} - Platform {platformName} - Flight {flight}
            </th>
          </tr>
          <tr>
            <th className="name-cell">NAME</th>
            <th>LOT #</th>
            <th>BWT</th>
            <th className="weight-class-cell">WT CLS</th>
            <th className="rack-cell">S RACK</th>
            <th className="rack-cell">B RACK</th>
            <th className="lift-cell">SQ-1</th>
            <th className="lift-cell">SQ-2</th>
            <th className="lift-cell">SQ-3</th>
            <th className="lift-cell">BP-1</th>
            <th className="lift-cell">BP-2</th>
            <th className="lift-cell">BP-3</th>
            <th className="lift-cell">DL-1</th>
            <th className="lift-cell">DL-2</th>
            <th className="lift-cell">DL-3</th>
          </tr>
        </thead>
        <tbody>
          {
            _.map(lifters, (lifter) => {
              const lifterDivision = _.first(lifter.divisions);
              let weightClass = '';
              if(lifterDivision) {
                const weightClassDoc = getLifterAwardsWeightClassDoc(meet, lifter, lifterDivision);
                if(weightClassDoc) {
                  weightClass = weightClassDoc.name;
                }
              }
              return (
                <tr key={lifter._id}>
                  <td className="name-cell">{lifter.name}</td>
                  <td>{lifter.lot}</td>
                  <td>{lifter.bodyWeight}</td>
                  <td className="weight-class-cell">{weightClass}</td>
                  <td className="rack-cell">{lifter.squatRackHeight}</td>
                  <td className="rack-cell">{lifter.benchRackHeight}</td>
                  <td className="lift-cell-wrapper"><LiftCell lift={_.get(lifter, ['lifts', 'squat', '1'])} /></td>
                  <td className="lift-cell-wrapper"><LiftCell lift={_.get(lifter, ['lifts', 'squat', '2'])} /></td>
                  <td className="lift-cell-wrapper"><LiftCell lift={_.get(lifter, ['lifts', 'squat', '3'])} /></td>
                  <td className="lift-cell-wrapper"><LiftCell lift={_.get(lifter, ['lifts', 'bench', '1'])} /></td>
                  <td className="lift-cell-wrapper"><LiftCell lift={_.get(lifter, ['lifts', 'bench', '2'])} /></td>
                  <td className="lift-cell-wrapper"><LiftCell lift={_.get(lifter, ['lifts', 'bench', '3'])} /></td>
                  <td className="lift-cell-wrapper"><LiftCell lift={_.get(lifter, ['lifts', 'dead', '1'])} /></td>
                  <td className="lift-cell-wrapper"><LiftCell lift={_.get(lifter, ['lifts', 'dead', '2'])} /></td>
                  <td className="lift-cell-wrapper"><LiftCell lift={_.get(lifter, ['lifts', 'dead', '3'])} /></td>
                </tr>
              );
            })
          }
        </tbody>
      </table>
    </div>
  );
};



class JurySheet extends Component {

  render() {
    const { meet } = this.props;

    const lifters = _.sortBy(meet.lifters, ['name']);

    return (
      <div className="jury-sheet">
        {
          _.map(getSessionOptions(), (session) => {
            const sessionLifters = _.filter(lifters, {session: session.value});
            const sessionCount = _.size(sessionLifters);
            if(!sessionCount) {
              return null;
            }

            return (
              <div key={session.value}>
                {
                  _.map(getPlatformOptions({}, meet), (platform) => {
                    const platformLifters = _.filter(sessionLifters, {platformId: platform.value});
                    const platformCount = _.size(platformLifters);

                    if(!platformCount) {
                      return null;
                    }

                    return (
                      <div key={platform.value}>
                        {
                          _.map(getFlightOptions(), (flight) => {
                            const flightLifters = _.filter(platformLifters, {flight: flight.value});
                            const flightCount = _.size(flightLifters);
                            if(!flightCount) {
                              return null;
                            }

                            return (
                              <SheetBody
                                key={flight.value}
                                meet={meet}
                                platformId={platform.value}
                                session={session.value}
                                flight={flight.value}
                                lifters={flightLifters}
                              />
                            );
                          })
                        }
                      </div>
                    );
                  })
                }
              </div>
            );
          })
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(JurySheet);
